<script setup lang="ts">
import MapControlPanel from '@/components/_common/navbar/MapControlPanel.vue';
import CommonSearch from '@/components/_common/CommonSearch.vue';
import GeofenceList from '@/components/geofence/list/GeofenceList.vue';
import GeofenceMap from '@/components/geofence/map/GeofenceMap.vue';
import GeofenceListBar from '@/components/geofence/list/GeofenceListBar.vue';
import GeofencesTabs from "@/components/geofence/list/GeofencesTabs.vue";
import SliderSearchTabsBar from '@/components/_common/SliderSearchTabsBar.vue';
import ThreeColumnLayout from "@/components/_common/ThreeColumnLayout.vue";

const typeId = 'geofencesTabs';

import {useSynchronizedUrlQuerySearchStore} from "@/composables/useSynchronizedUrlQuerySearchStore";
useSynchronizedUrlQuerySearchStore();

import { useSynchronizedSidebars } from "@/composables/useSynchronizedSidebars";
useSynchronizedSidebars({ defaultOpenSidebar: 'right', persistScoutOpenState: true });

import {useSynchronizedSearchGeofencesList} from "@/composables/useSynchronizedSearchGeofencesList";
useSynchronizedSearchGeofencesList()

import {useSynchronizedSearchSlideBar} from "@/composables/useSynchronizedSearchSlideBar";
useSynchronizedSearchSlideBar(typeId);

import {useResetChatOnSidebarClose} from "@/composables/useResetChatOnSidebarClose";
useResetChatOnSidebarClose();

import {useResetChatOnAccountOrUserChange} from "@/composables/useResetChatOnAccountOrUserChange";
useResetChatOnAccountOrUserChange();

import * as events from '@/events';
import {computed, onMounted, watch} from "vue";
import {useStore} from "vuex";
import {setTitle} from "@/utils/title";
import { getAccountGeofences } from '@gpx-spa/queries';
import NProgress from 'nprogress';
import { ADD } from '@/store/mutation-types';



const store = useStore();

// Get accountId from store
const accountId = computed(() => store.getters['auth/accountId']);

// Fetch geofences using vue-query
const { data: geofencesData, isLoading: isGeofencesLoading } = getAccountGeofences(
  accountId
);

// Update Vuex store when geofences data changes
watch(
  geofencesData,
  (newGeofences) => {
    if (newGeofences) {
      // Update the geofence store with the new data using commit (ADD is a mutation, not an action)
      // For namespaced modules, use the full path with the mutation constant
      store.commit(`geofence/${ADD}`, newGeofences);
    }
  },
  { immediate: true }
);

// Show/hide NProgress based on loading state
watch(isGeofencesLoading, (isLoading) => {
  if (isLoading) {
    NProgress.start();
  } else {
    NProgress.done();
  }
}, { immediate: true });

// Use filtered geofences from store (now populated by vue-query)
const geofences = computed(() => store.getters['geofence/filtered']);

setTitle('All Geofences');
onMounted(() => {
  events.trigger(events.names.GEOFENCE_LIST_VIEWED);
});
</script>


<template>
  <ThreeColumnLayout>
    <template #leftTop>
      <SliderSearchTabsBar  v-if="$can('view', 'Anchors')" :typeId="typeId" placeholder="Search Geofences..." >
        <template #tabs>
          <GeofencesTabs />
        </template>
      </SliderSearchTabsBar>
      <CommonSearch
        v-else
        placeholder="Search Geofences..."
      />
    </template>
    <template #left>
      <GeofenceList class="h-full" :geofences="geofences" />
    </template>
    <template #rightTop>
      <MapControlPanel>
        <template #filters>
          <GeofenceListBar />
        </template>
      </MapControlPanel>
    </template>
    <template #right>
      <GeofenceMap view="cluster" />
    </template>
  </ThreeColumnLayout>
</template>
